import { Controller } from 'react-hook-form'
import { TextField, FormHelperText } from '@material-ui/core'

const FormTextField = ({
  name,
  control,
  label,
  multiline = false,
  variant = 'outlined',
  error,
  required = false,
}) => (
  <>
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          label={label}
          multiline={multiline}
          error={!!error}
          variant={variant}
          required={required}
        />
      )}
    />
    {error && <FormHelperText error>{error.message}</FormHelperText>}
  </>
)

export default FormTextField
